import { H2, TextL } from '~/tenset-components'

export function VisionRoadmap() {
  return (
    <div className="flex flex-col items-center justify-center text-center max-w-screen-lg mx-auto gap-4">
      <H2 isBold>Vision for the Future</H2>

      <TextL>
        “We aim to preserve our core values: high-quality gems, buybacks, and
        robust, secure technical products. Our goal is to increase our
        visibility in the crypto world by entering new markets, establishing
        dozens of new partnerships, and helping more companies successfully
        launch their products. This will create more opportunities for our
        community to grow their wealth.”
      </TextL>
      <TextL>~ Karan, Founder of AlphablockZ Ventures Ltd.</TextL>
    </div>
  )
}
